<div class="d-flex flex-wrap flex-column IPO-card mb-3">
    <div class="p-2 IPO-card-header font-small leaf" [style.left]="translate.currentLang=='ar' ? '0':null"
    [style.right]="translate.currentLang=='en' ? '0':null" *ngIf="!DisabledEtrade ">
    {{'EtradeingClosed'|translate}}

</div>
    <div class="d-flex flex-column align-items-start text-color-theme font-medium mx-3 font-600">
        {{'timeLine'|translate}}
    </div>
    <br>

    <div  *ngIf="!ipoDocuments?.OprEvents  " class="text-center nodata">
        <img class="img-not-found-width" src="/assets/img/no-data-vector.png" />
        <div class="no-data-available mt-2 font-600" > {{'no-data-available'|translate}} </div>
    </div>

    <div *ngIf="ipoDocuments?.OprEvents  " class="timeline-wrapper "
    [ngClass]="lang == 'ar'? 'rtl timer-padding-right' : 'ltr timer-padding-left'">
        <ul class="StepProgress">
            <li 
            *ngFor="let ipo of  ipoDocuments?.OprEvents " 
            [class.is-done]="ipo.status == 0"
            [class.is-progress]="ipo.status == 1"
            class="StepProgress-item ">
                <div class="bold time text-color-theme font-small">{{ipo?.Date | date: 'dd/MM/yyyy'}}</div>
                <div class="text-color-theme font-medium font-600 ">{{lang == 'ar'? ipo?.NameAr : ipo?.NameEn}}</div>
                <div class="text-color-theme font-medium ">{{lang == 'ar'? ipo?.DescriptionAr : ipo?.DescriptionEn}}</div>
            </li>
        </ul>
    </div>
</div>
<div class="d-flex flex-wrap flex-column w-100 IPO-card my-2 ">
    <div class="d-flex flex-column align-items-start text-color-theme font-medium mx-3 font-600">{{ "pdf" | translate }}</div>
    <div class="d-flex flex-wrap justify-content-center my-2">
        <ng-container *ngIf="ipoDocuments?.Pdfs.length>0" >
            <div class="row w-100"  *ngFor="let i of getRowIndexes(ipoDocuments?.Pdfs.length)">
                <div class="col-6" *ngIf="ipoDocuments?.Pdfs[i]">
                    <div class="pdf-card clickable my-2">
                        <a target="_blank" [href]="ipoDocuments?.Pdfs[i]" class="d-flex flex-column align-items-center justify-content-center my-2 text-color-theme font-small font-600">
                            <img src="assets/img/PDF.svg" alt="">
                            {{'attachment' | translate}} {{i+1}}
                        </a>
                    </div>
                </div>
                <div class="col-6" *ngIf="ipoDocuments?.Pdfs[i + 1]">
                    <div class="pdf-card clickable my-2">
                        <a target="_blank" [href]="ipoDocuments?.Pdfs[i+1]" class="d-flex flex-column align-items-center justify-content-center my-2 text-color-theme font-small font-600">
                            <img src="assets/img/PDF.svg" alt="">
                            {{'attachment' | translate}} {{i+2}}
                        </a>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="ipoDocuments?.Pdfs[0]==''" >
            <div class="col-12">
                <div class="pdf-card my-2 d-flex flex-column align-items-center justify-content-center">
                    <img src="assets/img/noPdfFound.png">
                    <div class="my-2 font-small no-data-available mt-2 font-600">{{ "noPDF" | translate }}</div>
                </div>
            </div>
        </ng-container>
    </div>
</div>